import React from 'react'
import { graphql } from 'gatsby'
import SEO from '~/components/seo'

import '../../styles/bio-page.css'

import ReactMarkdown from 'react-markdown'

const AboutPage = ({
  data: {
    pageData: {
      frontmatter: { seo_title, seo_description, text, title },
    },
  },
}) => {
  const textWithNewlines = text.replace(/(?:\r\n|\r|\n)/g, '<br>')

  return (
    <>
      <SEO title={seo_title} description={seo_description} />
      <div className="page-layout bio-page page-container">
        <article className="bio-text">
          <h1 className="page-title">{title}</h1>
          <ReactMarkdown className="bio-paragraph" source={text} />
        </article>
      </div>
    </>
  )
}

export const query = graphql`
  query($slug: String) {
    pageData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        seo_title
        seo_description
        title
        text
      }
    }
  }
`

export default AboutPage
